import { render, staticRenderFns } from "./Storages.vue?vue&type=template&id=68e2e272&scoped=true&"
import script from "./Storages.vue?vue&type=script&lang=js&"
export * from "./Storages.vue?vue&type=script&lang=js&"
import style0 from "./Storages.vue?vue&type=style&index=0&id=68e2e272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e2e272",
  null
  
)

export default component.exports